// constants.js
export const ROUTES = {
  ROOT: "/",
  LOGIN: "/login",
  MAGIC_LOGIN: "/magic-login",
  NO_PERMISSION: "/no-permission",
  TABLE: "/Table",
  MULTI_PORTAL: "/multi-portal",
  VERIFY_CUSTOMER: "/verify-customer",
  THANK_YOU: "/thank-you",
  TIMESHEET_APPROVAL: "/timesheet/approval",
  BASIC_FORM: "/basic-form",
  INDUCTION_FORM: "/induction-form",
  WORKSPACE_SUB_INDUCTION: "/workspace/:workspaceId/sub/:id",
  WORKFORCE: "/workforce",
  ADMIN: "/admin",
  MANAGER: "/manager",
  EMPLOYEE: "/employee",
  CUSTOMERS: "/customers",
  CUSTOMER: "/customer",
  PROSPECT: "/prospect",
  REPORTS: "/reports",
  WASTE: "/waste-manage",
  SUB_CONTRACTOR: "/subcontractor",
  WORKFORCE_SETTINGS: "/workforce-settings",
  ESTIMATES: "/estimates",
  PROJECT_REGISTER: "/project-register",
  ACTIVITY: "/Activity",
  CLIENTS: "/clients",
  PROJECTS: "/projects",
  TASKS: "/tasks",
  ITEMS: "/items",
  TOOLS: "/tools",
  PRODUCTS: "/products",
  REQUEST: "/request",
  RETURN_REQUEST: "/return-request",
  PRODUCT_REQUEST: "/product-request",
  TRANSFER_REQUEST: "/transfer-request",
  AWAITING: "/awaiting",
  MESSAGES: "/messages",
  OHS: "/ohs",
  INDUCTION: "/induction",
  SUPPORT: "/support",
  ANNOUNCEMENT: "/announcement",
  SETTINGS: "/settings",
  MAINTENANCE: "/maintenance",
  SUMMARY: "/summary",
  WASTE_SUMMARY_SETTINGS: "/waste-summary-settings",
  WEIGHT_SCALE: "/weight-scale",
  WEIGH_BRIDGE: "/weigh-bridge",
  WEIGHTING_REPORTS: "/weighting-reports",
  VEHICLES: "/vehicles",
  LOAD_TYPE: "/load-type",
  WASTE_TYPE: "/waste-type",
  TIPPING_YARD: "/tipping-yard",
  TIPPING_REPORT: "/tipping-report",
  PROJECT_DAILY_REPORTS: "/project-daily-reports",
  DAILY_REPORTS: "/daily-reports",
  WORK_DOCKET: "/work-docket",
  REPORT_QUESTIONS: "/report-questions",
  REPORT_SETTINGS: "/report-settings",
  ROSTER: "/roster",
  TIME_TRACKING: "/time-tracking",
  TIME_SHEET: "/time-sheet",
  APPROVAL: "/approval",
  WORK_LOG: "/worklog",
  PAYROLL: "/payroll",
  LEADS: "/leads",
  CASE_2: "/case-2",
  PART_1: "/part-1",
  TASK_CLAIMS: "/task-and-claims",
  ANALYTICS: "/analytics",
  INVOICING: "/invoicing",
  CONTRACT_INVOICE: "/contract-invoice",
  DOCKET_INVOICE: "/docket-invoice",
  XERO_INVOICE: "/xero-invoice",
  FLEET: "/fleet",
  BROWSE_FILE: "/browse-file",
  VIEW_FILE: "/view-file",
  DASHBOARD: "/dashboard",
  INTELLIFLOW: "/intelliflow",
  DOCUMENT_PARSER: "/document-parser",

  // Customer Portal
  CUSTOMER_PORTAL: "/customer-portal",
  USER_MANAGEMENT: "/user-management",
  WARE_HOUSING: "/ware-housing",
  CALENDAR: "/Calendar",
  DOCKET_SIGNATURE: "/docket-signature",
  DRIVES: "/drives",
  WASTE_REQUEST: "/waste-request",
  WASTE_SUMMARY: "/waste-summary",
};

/**
 * Per-root override for how deep the "module" identity goes when comparing
 * pagination scope. Defaults to one segment (e.g. `/projects`). Roots listed
 * here widen scope to two segments so sibling sub-routes are treated as
 * distinct modules and trigger a pagination reset on switch.
 *
 * Examples:
 *   /customers/customer vs /customers/prospect          -> reset
 *   /workforce/admin   vs  /workforce/manager          -> reset
 *   /invoicing/contract vs /invoicing/docket           -> reset
 *   /reports/daily     vs  /reports/tipping            -> reset
 */
export const PAGINATION_SCOPE_SEGMENT_DEPTH: Record<string, 1 | 2> = {
  [ROUTES.CUSTOMERS]: 2,
  [ROUTES.CUSTOMER_PORTAL]: 2,
  [ROUTES.INTELLIFLOW]: 2,
  [ROUTES.INVOICING]: 2,
  [ROUTES.REPORTS]: 2,
  [ROUTES.TIME_TRACKING]: 2,
  [ROUTES.WASTE]: 2,
  [ROUTES.WORKFORCE]: 2,
};
